import { asset } from '@exodus/algorand-meta'
import { AccountState } from '@exodus/models'

export class AlgorandAccountState extends AccountState {
  static defaults = {
    cursor: '',
    balance: asset.currency.ZERO,
    accountReserve: asset.currency.defaultUnit(0.1),
    tokenBalances: {},
    mem: {
      loaded: false,
      rewards: asset.currency.defaultUnit(0),
      pendingRewards: asset.currency.defaultUnit(0),
      governanceAddresses: [],
    },
  }

  static _tokens = [asset]
}
